@if (showTooltip) {
  <span>
    <td-wb-tooltip-button class="td-wb-account-selector-tooltip__button"
                          [ariaLabel]="('tdWb.components.accountSelector.overlay.LINK_LABEL' | tdWbTranslate) + ', ' + ('tdWb.components.accountSelector.ACCOUNT' | tdWbTranslate)"
                          [tdWbOverlayToggle]="accountSelectorTooltipTemplate"
                          tooltipPosition="end-bottom"
                          tooltipSize="small" />
  </span>
}
<ng-template #accountSelectorTooltipTemplate>
  <td-wb-overlay>
    <td-wb-overlay-header>
      <span translate="tdWb.components.accountSelector.overlay.HEADER_LABEL"></span>
    </td-wb-overlay-header>
    <p class="td-wb-p td-wb-body-small"
       [innerHTML]="'tdWb.components.accountSelector.overlay.DESCRIPTION_LABEL' | tdWbTranslate"></p>
    <div>
      <a class="td-wb-link"
         tdWbHref="link_preferences_map">
        <span translate="tdWb.components.accountSelector.overlay.CHANGE_LINK"></span>
        <td-wb-icon iconId="caret-right--small"
                    [inline]="true" />
      </a>
    </div>
  </td-wb-overlay>
</ng-template>
